module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'sandbox'
      }
    }
  }, [_vm._v("Malware Analyzer")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Payload Records")])]), _vm._v(" "), _c('bootstrap-modal', {
    attrs: {
      "title": "Analysis Details",
      "name": "analysisJson"
    }
  }, [_c('json', {
    attrs: {
      "jsonObject": _vm.verdict.analysisResult
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v("Payload " + _vm._s(_vm.sha1Checksum) + " - " + _vm._s(_vm.size))]), _vm._v(" "), _c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion"
    }
  }, [_c('bootstrap-panel', {
    attrs: {
      "title": "Verdict Details"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.verdict.processingState === _vm.PROCESSING_COMPLETED) ? _c('div', [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Classification")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.verdict.classification))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.verdict.virusName))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Date Processed")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.epochDate(_vm.verdict.timestamp)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Analysis Details")]), _vm._v(" "), (_vm.hasAnalysisResult) ? _c('td', [_c('a', {
    attrs: {
      "href": "#analysisJson",
      "data-toggle": "modal"
    }
  }, [_vm._v("show")])]) : _c('td')])])])]) : _c('div', [_c('p', [_vm._v("Payload processing " + _vm._s(_vm.verdict.processingState))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.override === null) ? _c('div', [_c('p', [_vm._v("fetching overrides...")])]) : _c('div', [(_vm.override === '') ? _c('p', [_vm._v("No verdict override configured.")]) : _c('p', [_vm._v("\n              Verdict overridden to "), _c('strong', [_vm._v(_vm._s(_vm.override))])]), _vm._v(" "), _c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.overrideSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Override Verdict")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.override),
      expression: "override"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.override = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": _vm.override === ''
    }
  }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.classifications), function(verdict) {
    return _c('option', {
      domProps: {
        "selected": _vm.override === verdict,
        "value": verdict
      }
    }, [_vm._v("\n                    " + _vm._s(verdict) + "\n                  ")])
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])]), _vm._v(" "), (_vm.updateMessage) ? _c('p', [_vm._v(_vm._s(_vm.updateMessage))]) : _vm._e()])])])]), _vm._v(" "), _c('bootstrap-panel', {
    attrs: {
      "title": "Record Locations"
    }
  }, [_c('google-map', {
    attrs: {
      "coordinates": _vm.coordinates,
      "height": "400px"
    }
  })], 1), _vm._v(" "), _c('bootstrap-panel', {
    attrs: {
      "title": "Payload Records"
    }
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Serial")]), _vm._v(" "), _c('th', [_vm._v("Service Tag")]), _vm._v(" "), _c('th', [_vm._v("Protocol")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Url")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.recordsSorted), function(record, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.epochDate(record.timestamp)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.metadata.licenseCustomer))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'serial',
          params: {
            id: record.metadata.licenseSerial
          }
        }
      }
    }, [_vm._v(_vm._s(_vm.trim(record.metadata.licenseSerial, 8)))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.metadata.licenseServiceTag))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.metadata.protocol))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.trim(record.metadata.magic, 20)) + "\n              "), _c('bootstrap-popover', {
      attrs: {
        "placement": "top",
        "content": record.metadata.magic
      }
    }, [_vm._v("...")])], 1), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.trim(record.metadata.url, 20)) + "\n              "), _c('bootstrap-popover', {
      attrs: {
        "placement": "top",
        "content": record.metadata.url
      }
    }, [_vm._v("...")])], 1)])
  }))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d61f6a9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SandboxRecord.vue
// module id = 485
// module chunks = 2